/* eslint jsx-a11y/aria-role: 0 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CartCounter from '../CartCounter';

import './style.css';

class FloatingCart extends Component {
  handleCartClick = () => {
    this.props.showCart();
  }

  render() {
    if (!this.props.isProductPage) {
      return null;
    }

    return (
      <div className="floating-cart">
        <div onClick={this.handleCartClick}>
          <CartCounter color="#fff" cartQuantity={this.props.cartQuantity}/>
        </div>
      </div>
    );
  }
}

FloatingCart.propTypes = {
  isProductPage: PropTypes.bool.isRequired,
  showCart: PropTypes.func.isRequired
};

export default FloatingCart;



// WEBPACK FOOTER //
// ./src/components/FloatingCart/FloatingCart.jsx